export default function PHP_is_numeric() {
  return (
    <div>
      <h1>PHP_is_numeric</h1>
    </div>
  );
}
